import { format } from '../../utils';

export function getEntityAdminTypeLabel(params: {
  isChildRow: boolean;
  entityName: string;
  childEntityName: string | undefined;
}): string {
  return params.isChildRow ? (params.childEntityName ?? params.entityName) : params.entityName;
}

function pluralizeWord(word: string): string {
  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }
  if (/(?:s|x|z|ch|sh)$/i.test(word)) {
    return `${word}es`;
  }
  return `${word}s`;
}

export function pluralizeEntityAdminTypeLabel(label: string): string {
  const parts = label.trim().split(/\s+/);
  const last = parts.at(-1);
  if (last == null || last === '') {
    return label;
  }
  parts[parts.length - 1] = pluralizeWord(last);
  return parts.join(' ');
}

export function getEntityAdminBulkConfirmReason(params: {
  action: 'edit' | 'delete';
  count: number;
  entityName: string;
  childEntityName: string | undefined;
  isChildRow: boolean;
}): string {
  const typeLabel = getEntityAdminTypeLabel(params);
  const countedLabel = params.count === 1 ? typeLabel : pluralizeEntityAdminTypeLabel(typeLabel);
  return `Are you sure you want to ${params.action} ${format(params.count)} ${countedLabel}?`;
}
